<template>
  <div class="mt-16">
    <h1 class="heading-1 mb-8">
      {{ product.titles.raw }}
    </h1>

    <RatingInfo
      v-if="rating && !hideRating"
      anchor-id="reviews"
      class="mb-8"
      :rating
    />
    <PopularityStatsSalesCaption
      v-if="popularityStatsSales && popularityStatsSales[0]"
      :popularity-stats-sales="popularityStatsSales[0]"
    />
  </div>
</template>

<script lang="ts" setup>
import type { PopularityStatsSales } from '@backmarket/http-api/src/api-specs-checkout/popularity-stats/popularity-stats.types'
import type { GetProductResponse } from '@backmarket/http-api/src/api-specs-navigation-experience/product/product'
import type { Rating } from '@backmarket/http-api/src/api-specs-reviews/types/rating'

import PopularityStatsSalesCaption from '~/scopes/product/pages/Product-JP/components/PopularityStatsSalesCaption/PopularityStatsSalesCaption.vue'
import RatingInfo from '~/scopes/reviews/reviews-display/components/Rating/Rating.vue'

withDefaults(
  defineProps<{
    product: GetProductResponse
    rating?: Rating | null
    hideRating?: boolean
    popularityStatsSales?: PopularityStatsSales[] | null
  }>(),
  {
    rating: null,
    hideRating: false,
    popularityStatsSales: null,
  },
)
</script>
